import { 
    AppEnumHelper, 
    dateCompare, 
    DateFormatHelper, 
    DetailItem, 
    DetailSection, 
    DOMAIN_TYPES, 
    formatName, 
    PlanningEnums, 
    RecordMap
} from "@/Shared";

import { PlanningModel } from "../Models/PlanningModel";
import { AuditViewModel } from "@/Shared/Logic/ViewModels/AuditViewModel";
import { AuditModel } from "@/Shared/Logic/Models/AuditModel";
import { AccessRightModel, DocumentModel } from "@/Domains";

export interface PlanningVMParams {
    planning: PlanningModel;
    viewEnums: PlanningEnums;
    isDisplaying : boolean;
    accessRight : AccessRightModel;
     documentMap?: RecordMap<DocumentModel>;
}

export class PlanningViewModel {

    public id: number;

    public planningDate!: string;
    public startTime!: string;
    public endTime!: string;
    public note!: string;
    public contact!: string;
    public contactId!: number;
    public property!: string;
    public propertyId!: number;
    public agent!: string;
    public agentId!: number;
    public feedback!: string;
    public remarks!: string;
    public typeLabel!: string;
    public typeClass!: string;
    public audit! : AuditViewModel;
    public cardHeaderTitle!: string;
    public cardClass! : string;
    public model : PlanningModel;
    public isDeleted : boolean;
    private _documentMap?: RecordMap<DocumentModel>;
    


    public constructor(protected params : PlanningVMParams) {

        const {planning,viewEnums,isDisplaying, accessRight, documentMap} = this.params;

         this._documentMap = documentMap;

        this.id = planning?.id ?? 0;
        this.model = planning;
        this.contactId = planning?.contactId ?? 0;
        this.propertyId = planning?.propertyId ?? 0;
        this.agentId = planning?.agentId ?? 0;

        this.audit = new AuditViewModel(planning as AuditModel);

        this.planningDate = DateFormatHelper.toLocaleDateString(planning.planningDate) || "";
        this.startTime = planning?.startTime ?? "";
        this.endTime = planning?.endTime ?? "";
        this.note = planning?.note ?? "";
        this.feedback = String(planning?.feedback ?? "");
        this.remarks = planning?.remarks ?? "";

        this.contact = formatName(planning?.contact?.person);
        this.agent = formatName(planning?.agent?.person);

        this.property = String(planning.propertyId);
        this.typeLabel = AppEnumHelper.getLabel(this.params.viewEnums.PlanningTypeEnum, this.model?.type );

        this.initClassByType();
        this.cardHeaderTitle = `${this.typeLabel} - (ID : ${this.id})`;
        this.isDeleted = !!planning?.deletedAt
        this.cardClass = isDisplaying ? 'active' : '';
        
    }

    documentMap() : RecordMap<DocumentModel>|undefined {
            return this._documentMap;
        }

    private initClassByType() {
        const typeEnum = AppEnumHelper.getByValue(this.params.viewEnums.PlanningTypeEnum, this.model?.type );
        this.typeClass = "planning-type--" + (typeEnum?.key ?? "").toUpperCase();
    }


    get title() {
        return "Planning N° " + this.id + '|' + this.typeLabel;
    }

    getAllSections = () : DetailSection [] => {
            const sections: DetailSection [] =  [
                {
                    sectionFn : this.getGlobalSection,
                    legend : 'Opération',
                    type:  'box'
                },
                {
                    sectionFn : this.getReasonSection,
                    legend : 'Biens recherchés',
                    type:  'box'
                },
            ];

            if(this.params.accessRight.canAudit(DOMAIN_TYPES.Planning)) {
                sections.push({
                    sectionFn : this.audit.getAuditTrail,
                    legend : 'Traçabilité',
                    type:  'box'
                });
            }
            return sections;
    }        

    getGlobalSection = () => {
        return [
            { label: "N° Planning", value: this.id },
            { label: "Type", value: this.typeLabel },
            { label: "Date", value: this.planningDate },
            { label: "Heure de début", value: this.startTime },
            { label: "Heure de fin", value: this.endTime },
        ] as DetailItem[];
    }

    getReasonSection = () => {
        return [
            { label: "Agent", value: this.agent },
            { label: "Prospect", value: this.contact },
            { label: "Bien", value: this.property },
            { label: "Feedback", value: this.feedback },
            { label: "Remarques", value: this.remarks },
        ] as DetailItem[];
    }

    compareTo(other: PlanningViewModel): number {
        return dateCompare(this.model.createdAt ?? "", other.model.createdAt ?? "");
    }
}